import axios from "axios";
import * as actionTypes from "./actionTypes";

const initialState = {
    loading: false,
    data: []

}
const billingReportReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.GET_SEARCH_DATA_LIST_REQUEST: {
            return { ...state, loading: true }
        }
        case actionTypes.GET_SEARCH_DATA_LIST_SUCCESS: {

        }
        case actionTypes.GET_SEARCH_DATA_LIST_FAILED: {

        }
        case actionTypes.GET_BILLING_REPORT_COUNT: {
            return {...state}
        } 
        default:
            return state
    }
}
export  default billingReportReducer